import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Grid,
  Input,
  makeStyles,
  Typography,
} from '@material-ui/core';
import commonStyles from '../../../styles';
import CommonDialog from '../../../../components/common/modal';
import { compressImage } from '../../../../commonFunction/compressImage';
import { formatFileName } from '../../../../commonFunction';
import { changeConfirmMessage } from '../../../../store/eleCommon/customConfirmMessage';

const useStyles = makeStyles((theme) => ({
  wrap: {
    padding: '4px 8px',
    marginBottom: 8,
    background: '#fff',
    alignItems: 'center',
    border: '1px #c8c8c8 solid',
    flexWrap: 'nowrap',
  },
  radioWrap: {
    flexDirection: 'row',
  },
  require: {
    marginRight: 16,
    flexShrink: 0,
    '& span': { color: '#D83420' },
  },
  inputWrap: {
    position: 'relative',
    width: '70%',
    '& .MuiInput-root': {
      position: 'absolute',
      zIndex: 1,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      '&::before': {
        content: 'none',
      },
      '&::after': {
        content: 'none',
      },
    },
  },
  boxLbl: {
    zIndex: 2,
    color: theme.palette.primaryColor,
    background: '#fff',
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 700,
    lineHeight: 1.6,
    letterSpacing: 0,
    padding: '9px 0 5px',
    pointerEvents: 'none',
    wordBreak: 'break-all',
  },
  dateLbl: {
    zIndex: 2,
    background: '#fff',
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 700,
    lineHeight: 1.6,
    letterSpacing: 0,
    padding: '9px 0 5px',
    pointerEvents: 'none',
  },
  input: {
    opacity: 0,
  },
}));

export default function RegisterCustomerCard(props) {
  const {
    open,
    setOpen,
    registrationDate,
    getCustomerCards,
    postCustomerCards,
    customerId,
  } = props;

  const common = commonStyles();
  const classes = useStyles();
  const dispatch = useDispatch();

  const [fileData, setFileData] = useState({});

  const processing = useRef(false);

  const onSubmit = async () => {
    if (processing.current) return;
    processing.current = true;
    setOpen(false);
    await postCustomerCards({
      customerId,
      fileData,
      registrationDate,
    });
    setFileData({});
    // リロードして最新の情報を取得
    getCustomerCards();
    processing.current = false;
  };

  const selectConfirm = () => {
    dispatch(changeConfirmMessage({
      title: '確認',
      msgList: [
        '登録してよろしいですか？',
      ],
      buttons: [
        {
          label: 'CANCEL',
          set: () => {},
          classes: common.buttonsSecondary,
        },
        {
          label: 'OK',
          set: onSubmit,
          classes: common.buttonsPrimary,
        },
      ],
    }));
  };

  const onFileInputChange = async (e) => {
    const inputFile = e.target.files[0]; // fileList obj
    // 画像ファイルのみが対象にする
    if (/^image/.test(inputFile.type)) {
      const compressedImage = await compressImage(inputFile);
      const data = {
        file: compressedImage,
        fileName: formatFileName(inputFile).join('.'),
      };
      setFileData(data);
    } else if (/^application\/pdf/.test(inputFile.type)) {
      const data = {
        file: inputFile,
        fileName: formatFileName(inputFile).join('.'),
      };
      setFileData(data);
    }
    // 表示名変更後に再度同じファイルをアップできるようにするため
    e.target.value = '';
  };

  return (
    <CommonDialog
      open={open}
      onClose={() => {
        return setOpen(false);
      }}
      title="顧客カードの新規登録"
      width={480}
      buttons={{
        label: '登録',
        disabled: !fileData.fileName || fileData.fileName.length > 400,
        onClick: selectConfirm,
      }}
    >
      <Grid className={common.body}>
        <Grid container className={`${classes.wrap}`}>
          <Typography className={`${common.title6} ${classes.require}`}>
            登録日<span>＊</span>
          </Typography>
          <Grid className={classes.inputWrap}>
            <Typography className={classes.dateLbl}>
              {registrationDate}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.wrap}>
          <Typography className={`${common.title6} ${classes.require}`}>
            ファイル<span>＊</span>
          </Typography>
          <Grid className={classes.inputWrap}>
            <Typography className={classes.boxLbl}>
              {fileData.fileName ? fileData.file.name : '選択'}
            </Typography>
            <Input
              type="file"
              onChange={(ev) => onFileInputChange(ev)}
              inputProps={{
                accept: 'image/*, .pdf',
              }}
              className={classes.input}
            />
          </Grid>
        </Grid>
      </Grid>
    </CommonDialog>
  );
}
